import { z } from 'zod';
// GET /v1/health — see docs/api.md §3.1
export const HealthResponseSchema = z.object({
    status: z.literal('ok'),
    /** Git SHA or "dev" outside of a CI build. */
    version: z.string(),
});
//# sourceMappingURL=meta.js.map